<template>
  <div>
    <v-btn :color="ui.colorError" flat dark @click="openDialog()">
      <v-icon left>
        manage_accounts
      </v-icon>
      User Setup
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor"> person </v-icon>
            <span :class="ui.textHeadline">
              <div :class="ui.textColorBlue">
                User Setup
              </div>
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheadingBold">
              {{stepInfo.title}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.msg}}
            </div>
          </v-layout>
          <v-form v-model="valid" lazy-validation>
            <v-container :class="ui.bkgdColor" v-if="this.step == 1">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs10>
                  <v-text-field
                  v-model="localForm.nfirst"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="account_circle"
                  hint="first name"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs10>
                  <v-text-field
                  v-model="localForm.nmid"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="contact_page"
                  hint="middle name"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs10>
                  <v-text-field
                  v-model="localForm.nlast"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="account_box"
                  hint="last name"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container :class="ui.bkgdColor" v-if="this.step == 2">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs10>
                  <v-text-field
                  v-model="localForm.nfirstCheck"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="account_circle"
                  hint="retype first name"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2"
              v-if="this.localForm.nmid !== ''">
                <v-flex xs10>
                  <v-text-field
                  v-model="localForm.nmidCheck"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="contact_page"
                  hint="retype middle name"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs10>
                  <v-text-field
                  v-model="localForm.nlastCheck"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="account_box"
                  hint="last name check"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container :class="ui.bkgdColor" v-if="this.step == 3">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs10>
                  <v-text-field
                  v-model="localForm.npref"
                  :rules="ruleMustBeNotUndefinedANDLessThan100"
                  prepend-icon="portrait"
                  hint="preferred name"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container :class="ui.bkgdColor" v-if="this.step == 4">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs12>
                  <v-select
                    v-model="localForm.titleModel"
                    :items="titleModel"
                    color="wplblue0"
                    prepend-icon="title"
                    hint="user selection is locked"
                    persistent-hint
                    readonly
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container :class="ui.bkgdColor" v-if="this.step == 5">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs10>
                  <v-text-field
                  v-model="localForm.ppri"
                  :rules="mustBeMobilePhoneNumber"
                  :mask="mask"
                  prepend-icon="phone"
                  prefix="+61"
                  hint="mobile phone number"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container :class="ui.bkgdColor" v-if="this.step == 6">
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> account_circle </v-icon>
                  </v-avatar>
                  First name
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.nfirst}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> contact_page </v-icon>
                  </v-avatar>
                  Middle Name
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.nmid}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> account_box </v-icon>
                  </v-avatar>
                  Last Name
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.nlast}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> portrait </v-icon>
                  </v-avatar>
                  Preferred Name
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <div v-if="localForm.npref === ''">
                    NA
                  </div>
                  <div v-else>
                    {{localForm.npref}}
                  </div>
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> phone </v-icon>
                  </v-avatar>
                  Phone
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{this.displayMobilePhoneNumber9Digits(localForm.ppri)}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> public </v-icon>
                  </v-avatar>
                  Country
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  Australia
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> title </v-icon>
                  </v-avatar>
                  User Title
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading" v-if="userTitle !== null">
                  {{userTitle}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :text-color="ui.colorError" class="subheading" v-if="userTitle === null">
                  Not Valid !
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> person_add_alt </v-icon>
                  </v-avatar>
                  User Verificaton Process
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  The reason why we collect personal data is to enable App operation and provide best user experience. Data privacy is our number one priority. Please ensure you use your legal name and we strongly recommend to use your personal email address. Our primary form of communication is email and we may contact you to seek clarification with respect to your new account application. Please allow 2 business days to process your application and activate user account.
                </div>
              </v-layout>
            </v-container>
          </v-form>

        </v-card-text>

        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat
          class="hidden-xs-only">
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-btn
          class="hidden-sm-and-up"
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon> exit_to_app </v-icon>
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-xs-only"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon left> navigate_before </v-icon>
            Back
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-sm-and-up"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_before </v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn v-if="this.step === 2 &&
          this.namesCheck === false &&
          this.localForm.nfirstCheck !== '' &&
          this.localForm.nlastCheck !== ''"
           :color="ui.colorError" flat>
            <v-icon left> error </v-icon>
            NAME !
          </v-btn>
          <v-btn :disabled="!valid" v-if="this.step < 6 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-xs-only">
            <v-icon left> navigate_next </v-icon>
            Next
          </v-btn>
          <v-btn :disabled="!valid" v-if="this.step < 6 && this.enableNextBtn"
          class="hidden-sm-and-up"
          @click="nextStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid" v-if="enableSubmit"
          class="hidden-xs-only"
          @click="submitUserSetup()" :color="ui.colorWarning" flat>
            <v-icon left> add </v-icon>
            Submit
          </v-btn>
          <v-btn :disabled="!valid" v-if="enableSubmit"
          class="hidden-sm-and-up"
          @click="submitUserSetup()" :color="ui.colorWarning" flat>
            <v-icon> add </v-icon>
          </v-btn>
          <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnSpin from "@/frame/animation/components/BtnSpin";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import { mapGetters } from "vuex";
export default {
  components: {
    BtnSpin
  },
  // eslint-disable-next-line
  mixins: [
    adminFunctions,
    docRevsModFunctions,
    apptheme,
    ruleTextfield,
    storeFunctions,
    changeDetail,
    displayFunctions
  ],
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      mask: "### ### ###",
      btnSpinChangeDetail: false,
      valid: true,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      },
      indeterminateProgressBar: false,
      step: 0,
      titleModel: [
        "First Name + Last Name",
        "Preferred Name + Last Name",
        "Middle Name + Last Name",
        "First Name + Middle Name + Last Name"
      ],
      localForm: {
        nlast: "", // last name
        nlastCheck: "",
        nfirst: "", // first name
        nfirstCheck: "",
        nmid: "", // middle name
        nmidCheck: "",
        npref: "", // name preferred
        titleModel: "First Name + Last Name",
        title: "",
        ppri: "" // primary phone entered
      },
      info: [
        {
          step: 0,
          title: "User Name Setup",
          // eslint-disable-next-line
          msg: "User name is essential for App operation and must be setup. User name must be legal name as shown on drivers licence or passport. The name is only used for the app operation, the data privacy policy is in force.",
          icon: ""
        },
        {
          step: 1,
          title: "Setup First, Middle and Last Name",
          // eslint-disable-next-line
          msg: "User first and last name are minimum requirements for app operations.",
          error: "Verify the names",
          icon: ""
        },
        {
          step: 2,
          title: "Retype the Names",
          // eslint-disable-next-line
          msg: "Verification step to ensure high data quality. Once names are submitted it is not possible to change by the user, and admin process is required. Please recheck the names.",
          error: "Recheck the first and last name, as they do not match",
          icon: ""
        },
        {
          step: 3,
          title: "Preferred First Name (Optional)",
          // eslint-disable-next-line
          msg: "Type your preferred first name in the organisation, which may be different to you legal first name.",
          error: "Recheck the first and last name, as they do not match",
          icon: ""
        },
        {
          step: 4,
          title: "Select Document Title",
          // eslint-disable-next-line
          msg: "Document title is a profile identifier in all documents, activity logs, actions. Please select preferred title",
          error: "Recheck the first and last name, as they do not match",
          icon: ""
        },
        {
          step: 5,
          title: "Additional Comms",
          // eslint-disable-next-line
          msg: "The phone number is used as a secondary communication system after email. The mobile phone can be used as two factor authentication (2FA) and verification system.  You must be an owner of a mobile phone number service in Australia (+61). Please enter the phone number in correct format (XXX XXX XXX) then press next to continue.",
          error: "Verify the phone number format.",
          icon: ""
        },
        {
          step: 6,
          title: "Verify and Submit",
          // eslint-disable-next-line
          msg: "Verify entered information. Reminder, that entered data must consist of legal names which could be to identify the  user in the App as user in the App. If you need to edit then return to previous step. Admin will verify your request and activate the account.",
          error: "Recheck the first and last name, as they do not match",
          icon: ""
        }
      ]
    };
  },
  created() {
    this.saveToStore(this.getUser);
    // this.startUserStore();
  },
  computed: {
    ...mapGetters(["getDetailBasic", "getDetailChar", "getUser"]),
    ui() {
      return this.uiTheme1;
    },
    stepInfo() {
      return this.info[this.step];
    },
    namesCheck() {
      let logic = false;
      if (
        this.localForm.nfirstCheck !== "" &&
        this.localForm.nlastCheck !== "" &&
        this.localForm.nfirstCheck === this.localForm.nfirst &&
        this.localForm.nmidCheck === this.localForm.nmid &&
        this.localForm.nlastCheck === this.localForm.nlast
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableSubmit() {
      let logic = false;
      if (
        this.step === 6 &&
        this.userTitle !== null &&
        this.btnSpinChangeDetail === false
      ) {
        logic = true;
      } else if (this.btnSpinChangeDetail === true) {
        logic = false;
      } else {
        logic = false;
      }
      return logic;
    },
    enableNextBtn() {
      let logic = false;
      if (this.step == 0) {
        logic = true;
      } else if (this.step == 1 && this.localForm.nfirst !== "") {
        logic = true;
      } else if (this.step == 2) {
        if (this.namesCheck === true) {
          logic = true;
        } else {
          logic = false;
        }
      } else if (this.step == 3) {
        logic = true;
      } else if (this.step == 4 && this.localForm.titleModel !== "") {
        logic = true;
      } else if (this.step == 5 && this.localForm.ppri !== "") {
        logic = true;
      } else if (this.step == 6 && this.userTitle !== null) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    userTitle() {
      let name = null;
      let first = this.localForm.nfirst;
      let last = this.localForm.nlast;
      let middle = this.localForm.nmid;
      let pref = this.localForm.npref;
      if (this.localForm.titleModel == "First Name + Last Name") {
        name = first + " " + last;
      }
      if (this.localForm.titleModel == "Preferred Name + Last Name") {
        if (pref == "") {
          name = null;
        } else {
          name = pref + " " + last;
        }
      }
      if (this.localForm.titleModel == "Middle Name + Last Name") {
        if (middle == "") {
          name = null;
        } else {
          name = first + " " + last;
        }
      }
      if (this.localForm.titleModel == "First Name + Middle Name + Last Name") {
        if (middle == "") {
          name = null;
        } else {
          name = first + " " + middle + " " + last;
        }
      }
      return name;
    }
  },
  methods: {
    nextStep(step) {
      this.step = step + 1;
    },
    previousStep(step) {
      this.step = step - 1;
    },
    openDialog() {
      this.dialog = true;
      this.step = 0;
      this.btnSpinReadResult = false;
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    // updateStoreforUserSetupORG() {
    //   let basic = this.getUser.basic;
    //   let char = this.getUser.char;
    //
    //   // update basic
    //   basic.title = this.userTitle;
    //   basic.act = this.checkUserOK(this.getDetailBasic);
    //   // update char
    //   char.nfirst = this.localForm.nfirst;
    //   char.nmid = this.localForm.nmid;
    //   char.nlast = this.localForm.nlast;
    //   char.npref = this.localForm.npref;
    //
    //   // eslint-disable-next-line
    //   this.$store.dispatch("changeDetailBasic", basic);
    //   this.$store.dispatch("changeDetailChar", char);
    //   this.saveDocumentRevMod(1.11, 1); // user initial steup
    // },
    updateStoreforUserSetup() {
      let basic = this.getUser.basic;
      let char = this.getUser.char;

      // update basic
      basic.title = this.userTitle;
      basic.act = this.checkUserOK(this.getDetailBasic);
      // update char
      char.nfirst = this.localForm.nfirst;
      char.nmid = this.localForm.nmid;
      char.nlast = this.localForm.nlast;
      char.npref = this.localForm.npref;
      char.ppri = this.localForm.ppri;

      // eslint-disable-next-line
      this.$store.dispatch("changeDetailBasic", basic);
      this.$store.dispatch("changeDetailChar", char);
      this.saveDocumentRevMod(1.11, 1); // user initial steup
    },
    submitUserSetup() {
      this.btnSpinChangeDetail = true;
      this.updateStoreforUserSetup();
      // Finish User Setup
      this.changeDetail("user");
    }
  }
};
</script>
